import * as React from 'react';
import { useRef, useEffect, useState } from 'react';
import { CHEVRON_SKINNY_SVG } from "../assets";
import $ from 'jquery';
import { ClickAwayListener } from '@material-ui/core';
var DropdownMenu = function (props) {
    var menu = useRef(null);
    var _a = useState(0), menuWidth = _a[0], setMenuWidth = _a[1];
    var _b = useState(-1), forceFocus = _b[0], setForceFocus = _b[1];
    var _c = useState(), subItemsExist = _c[0], setSubItemsExist = _c[1];
    useEffect(function () {
        if (menu.current) {
            setMenuWidth(menu.current.clientWidth);
        }
    }, []);
    // Check if subitems exist
    useEffect(function () {
        if (props.menuItems.some(function (item) { return item === null || item === void 0 ? void 0 : item.subItems; })) {
            setSubItemsExist(true);
        }
    }, []);
    return (React.createElement(ClickAwayListener, { onClickAway: function () {
            props.onRequestClose && props.onRequestClose();
        } },
        React.createElement("div", { className: "DropdownMenu " + props.className + " " + (subItemsExist ? 'reverse' : ''), id: "DropDownNav", onKeyDown: function (key) {
                if (key.key == 'ArrowDown') {
                    var elems = $(key.target).parent().find('li:not(.sub-item)');
                    var index = elems.index(key.target);
                    if (index >= (elems.length - 1)) {
                        elems[0].focus();
                    }
                    else {
                        elems[index + 1].focus();
                    }
                    key.preventDefault();
                    key.stopPropagation();
                    setForceFocus(-1);
                }
                else if (key.key == 'ArrowUp') {
                    var elems = $(key.target).parent().find('li:not(.sub-item)');
                    var index = elems.index(key.target);
                    if (index == 0) {
                        elems[elems.length - 1].focus();
                    }
                    else {
                        elems[index - 1].focus();
                    }
                    key.preventDefault();
                    key.stopPropagation();
                    setForceFocus(-1);
                }
            } },
            React.createElement("ul", { className: "menu", ref: menu }, props.menuItems.filter(Boolean).map(function (item, index) {
                return (React.createElement("li", { className: "item", key: index, onClick: function () {
                        if (item.onClick) {
                            item.onClick();
                            props.onRequestClose && props.onRequestClose();
                        }
                    }, onKeyDown: function (key) {
                        if (key.key == 'ArrowLeft' && props.reverse) {
                            var elem = $(key.currentTarget).find('.submenu');
                            if (elem.length) {
                                setForceFocus(index);
                                $(elem).find('.sub-item')[0].focus(); // ToDo: This cant be focused, stays
                                key.preventDefault();
                                key.stopPropagation();
                            }
                        }
                    } },
                    item.text,
                    item.subItems ?
                        React.createElement("img", { className: "chevron", src: CHEVRON_SKINNY_SVG, alt: "arrowRight" })
                        : null,
                    item.subItems && item.subItems.length > 0 ?
                        React.createElement("ul", { className: "submenu " + (forceFocus == index ? 'force-focus' : ''), id: "DropDownSubNav" + index, style: props.reverse ? { left: -menuWidth } : { left: menuWidth - 1 } }, item.subItems.map(function (subitem, subIndex) {
                            return (React.createElement("li", { className: "item sub-item", key: subIndex, onClick: function () {
                                    if (subitem.onClick) {
                                        subitem.onClick();
                                        props.onRequestClose && props.onRequestClose();
                                    }
                                } }, subitem.text));
                        }))
                        : null));
            })))));
};
export default DropdownMenu;
//# sourceMappingURL=DropdownMenu.js.map